import { AxiosInstance, isAxiosError } from 'axios'
import { Boleto, BoletoAluguel, BoletoCommon, BoletoCondominio, Sistema, TipoDocAluguel, TipoDocCondominio } from './boleto'
import Papa from 'papaparse'

export type ListBoletosRequestCommon = {
    tipo_relacao: string
    somente_vencidos: boolean
    vencimento_inicio: string
    vencimento_fim: string
}

export type ListBoletosRequestCondominio = {
    tipo_sistema: Sistema.CONDOMINIO
    tipo_doc?: TipoDocCondominio
    codigo_condominio: number
    bloco?: string
    codigo_unidade?: number
} & ListBoletosRequestCommon

export type ListBoletosRequestAluguel = {
    tipo_sistema: Sistema.ALUGUEL
    tipo_doc?: TipoDocAluguel
    codigo_imovel?: number
} & ListBoletosRequestCommon

export type ListBoletoRequest =
    ListBoletosRequestAluguel
    |
    ListBoletosRequestCondominio


export const isBoletoAluguel = (boleto: Boleto): boleto is BoletoAluguel => boleto.sistema === Sistema.ALUGUEL
export const isBoletoCondominio = (boleto: Boleto): boleto is BoletoCondominio => boleto.sistema === Sistema.CONDOMINIO      
    

export class BoletoService {
    constructor(
        private api: AxiosInstance
    ) { }


    async list(request: ListBoletosRequestAluguel): Promise<BoletoAluguel[]>;
    async list(request: ListBoletosRequestCondominio): Promise<BoletoCondominio[]>;
    async list(request: ListBoletoRequest): Promise<BoletoAluguel[]|BoletoCondominio[]> {
        try {
            

            let { data } = await this.api.get<Boleto[]>('boletos', {
                params: {
                    ...request
                }
            })

            if (data && !(data instanceof Array)) {
                data = [data]
            }

            

            data.sort((a, b) => {
                if (a.sistema === Sistema.CONDOMINIO && b.sistema === Sistema.CONDOMINIO) {
                    if (a.unidade.descricao == b.unidade.descricao) {
                        return a.dataVencimento < b.dataVencimento ? 1 : -1
                    }
                    return a.unidade.descricao < b.unidade.descricao ? -1 : 1
                }
                if (a.sistema === Sistema.ALUGUEL && b.sistema === Sistema.ALUGUEL) {
                    let ta = `${a.imovel.subcodigo} - ${a.imovel.filial.abrev}`
                    let tb = `${b.imovel.subcodigo} - ${b.imovel.filial.abrev}`
                    if (ta === tb) {
                        return a.dataVencimento < b.dataVencimento ? 1 : -1
                    }
                    return ta < tb ? -1 : 1
                }
                return 0
            })

            if (request.tipo_sistema === Sistema.ALUGUEL) {
                return data.filter(isBoletoAluguel)
            } else {
                return data.filter(isBoletoCondominio)
            }

        } catch (error) {
            if (isAxiosError(error)) {
                console.error(error.response?.data)
            } else if (error instanceof Error) {
                console.error(error)
            }
            return []
        }
    }

    async exportToExcel(boletos: Boleto[]) {

        let rows = boletos.map(boleto => {
            let row =
            {
                Unidade: boleto.sistema === Sistema.CONDOMINIO ? boleto.unidade.descricao : `${boleto.imovel.subcodigo} - ${boleto.imovel.filial.abrev}`,
                Endereco: boleto.sistema === Sistema.CONDOMINIO ? boleto.unidade.condominio.endereco.enderecoCompleto : boleto.imovel.endereco.enderecoCompleto,
                Vencimento: (new Date(boleto.dataVencimento)).toLocaleDateString(),
                Valor: boleto.valorAtualizado.toLocaleString(),
                Mes: boleto.competencia,
                TipoDoc: boleto.tipoDOC
            }
            return row
        })

        let csv = Papa.unparse(rows, {
            delimiter: ';',
            quotes: true,
            header: true
        })

        return new File([csv], 'relatorio.csv', {
            type: "text/csv"
        })
    }
}